import { Event as SentryEvent } from '@sentry/types';
import {
    sendEnlargeMemoryArraysErrorFact,
    sendMemoryAccessOutOfBoundsErrorFact,
    sendMemoryAllocationErrorFact, sendOutOfMemoryErrorFact
} from '../stat/factHelpers';


const userSentErrors = new Set();

function checkIsGoogleApiError(event: SentryEvent) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rawErrorData: {[key: string]: any} = event?.extra?.__serialized__;
    return rawErrorData?.error === 'idpiframe_initialization_failed';
}

function mutateGoogleApiErrorEvent(event: SentryEvent) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rawErrorData: {[key: string]: any} = event?.extra?.__serialized__;
    const exception = event.exception.values[0];
    exception.type = 'GoogleApiError';
    exception.value = `${rawErrorData?.details} (${rawErrorData?.error})`;
    exception.mechanism.synthetic = false;
    exception.mechanism.type = 'onerror';
}

export function startupConfigureSentry() {
    window.Sentry.configureScope((scope) => {
        // transform non-error exceptions
        scope.addEventProcessor((event: SentryEvent) => {
            if (checkIsGoogleApiError(event)) {
                mutateGoogleApiErrorEvent(event);
            }

            return new Promise((resolve) => resolve(event));
        });

        // unity client errors facts
        scope.addEventProcessor((event: SentryEvent) => {
            const errorMessage = event.exception?.values?.[0]?.value;
            const allocateErrorRegexp = /allocate memory/i;
            const enlargeMemoryRegexp = /enlarge memory arrays/i;
            const outOfMemoryRegexp = /(out of memory)/i;
            const outOfBoundsRegexp = /(memory access out of bounds|Out of bounds memory access)/i;

            if (!errorMessage) {
                return new Promise((resolve) => resolve(event));
            }

            if (allocateErrorRegexp.test(errorMessage)) {
                sendMemoryAllocationErrorFact();
                return null;
            }

            if (enlargeMemoryRegexp.test(errorMessage)) {
                sendEnlargeMemoryArraysErrorFact();
                return null;
            }

            if (outOfBoundsRegexp.test(errorMessage)) {
                sendMemoryAccessOutOfBoundsErrorFact();
                return null;
            }

            if (outOfMemoryRegexp.test(errorMessage)) {
                sendOutOfMemoryErrorFact();
                $(document).trigger('notEnoughMemory');
                return null;
            }

            return new Promise((resolve) => resolve(event));
        });

        // numeric errors filter
        scope.addEventProcessor((event: SentryEvent) => {
            if (!event.exception) {
                return event;
            }

            const errorMessage = event.exception?.values?.[0]?.value;
            const numMatcher = /^[0-9]+$/;

            if (numMatcher.test(errorMessage)) {
                console.warn('Filtering meaningless numeric messages');
                return null;
            }

            return event;
        });

        // repeated errors filter
        scope.addEventProcessor((event: SentryEvent) => {
            const errorMessage = event.exception?.values?.[0]?.value;

            if (userSentErrors.has(errorMessage)) {
                console.warn('Filtering repeated error message');
                return null;
            }

            userSentErrors.add(errorMessage);
            return event;
        });
    });
}
